import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs md:text-sm font-label font-medium mb-4">
            Browse Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Dive into organized product categories and find exactly what you need with the vigorbuy spreadsheet comparison system.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} category - vigorbuy spreadsheet`}
                  title={`${cat.name} product category on vigorbuy spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              <div className="px-3 py-3 md:px-4 md:py-3.5">
                <h3 className="text-sm md:text-base font-label font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap truncate">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 leading-snug line-clamp-2">
                  {cat.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}